// @ts-check

export const PLAN_ID = {
    free: 'free',
    minimum: 'minimum',
};

export const DOWNGRADE_TARGET_PLAN_ID = PLAN_ID.minimum;
